const cloneDeep = require('lodash/cloneDeep');

export var objects = {
    cloneTo,
    isEmpty,
    openBlob,
    downloadBlob,
    readBlobAsText,
}

// clone an object to an existing object
export function cloneTo(obj1, obj2) {
    // remove props not in obj2
    Object.keys(obj1)
        .filter(key => !obj2.hasOwnProperty(key))
        .forEach(key => delete obj1[key]);

    // clone props from obj2
    for (let key in obj2) {
        obj1[key] = cloneDeep(obj2[key]);
    }
}

export function isEmpty(obj) {
    return !obj || Object.keys(obj).length === 0;
}

export function openBlob(blob) {
    let url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    // URL.revokeObjectURL(url); // Causes downloading PDF via button on page to fail in Chrome
}

export function downloadBlob(blob, filename = null) {
    let url = URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.style = 'display: none';
    a.href = url;
    a.download = filename || blob.name || Date.now();
    document.body.appendChild(a);
    a.click();
    a.parentNode.removeChild(a);
    setTimeout(() => {
        URL.revokeObjectURL(url);
    });
}

export function readBlobAsText(blob, encoding = 'utf8') {
    let reader = new FileReader();
    let loadingPromise = new Promise((res, rej) => {
        reader.onload = (e) => {
            res(e.target.result);
        };
        reader.onerror = rej;
    });
    reader.readAsText(blob, encoding);
    return loadingPromise;
}